var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 125,
    viewBox: "0 0 96 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5743 15.8994C41.8209 14.5435 54.1798 14.5435 66.4264 15.8994C73.207 16.6594 78.6774 21.9992 79.4731 28.8036C80.9243 41.2248 80.9243 53.7728 79.4731 66.194C78.6774 72.9984 73.207 78.3382 66.4264 79.0982C54.1798 80.4541 41.8209 80.4541 29.5743 79.0982C22.7937 78.3382 17.3233 72.9984 16.5276 66.194C15.0767 53.7741 15.0767 41.2274 16.5276 28.8075C16.9301 25.5018 18.4371 22.4289 20.8043 20.0867C23.1716 17.7446 26.2605 16.2705 29.5703 15.9034M48.0003 27.7348C48.7877 27.7348 49.5428 28.0476 50.0996 28.6043C50.6563 29.1611 50.9691 29.9162 50.9691 30.7036V44.53H64.7956C65.5829 44.53 66.338 44.8428 66.8948 45.3996C67.4515 45.9563 67.7643 46.7114 67.7643 47.4988C67.7643 48.2861 67.4515 49.0412 66.8948 49.598C66.338 50.1547 65.5829 50.4675 64.7956 50.4675H50.9691V64.294C50.9691 65.0813 50.6563 65.8365 50.0996 66.3932C49.5428 66.95 48.7877 67.2627 48.0003 67.2627C47.213 67.2627 46.4579 66.95 45.9011 66.3932C45.3444 65.8365 45.0316 65.0813 45.0316 64.294V50.4675H31.2051C30.4178 50.4675 29.6627 50.1547 29.1059 49.598C28.5492 49.0412 28.2364 48.2861 28.2364 47.4988C28.2364 46.7114 28.5492 45.9563 29.1059 45.3996C29.6627 44.8428 30.4178 44.53 31.2051 44.53H45.0316V30.7036C45.0316 29.9162 45.3444 29.1611 45.9011 28.6043C46.4579 28.0476 47.213 27.7348 48.0003 27.7348Z",
    fill: "#77a042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSurvey);
export default __webpack_public_path__ + "static/media/add-survey.c1b0ceba8a2279cb5c6a65087c06e188.svg";
export { ForwardRef as ReactComponent };